import { render, staticRenderFns } from "./manageNnitAdd-detail.vue?vue&type=template&id=9d76d95e&scoped=true"
import script from "./manageNnitAdd-detail.vue?vue&type=script&lang=js"
export * from "./manageNnitAdd-detail.vue?vue&type=script&lang=js"
import style0 from "./manageNnitAdd-detail.vue?vue&type=style&index=0&id=9d76d95e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d76d95e",
  null
  
)

export default component.exports